<template>
  <layout-main-inner title="培训统计">
    <train-data />
    <train-time-data />
  </layout-main-inner>
</template>

<script>
import TrainData from '../home/train-data.vue'
import TrainTimeData from '../home/train-time-data.vue'
export default {
  name: 'StatTrain',
  components: {
    TrainData, TrainTimeData
  }
}
</script>

<style>

</style>
